import { Component, Inject, OnInit } from '@angular/core'
import { Router } from '@angular/router'
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog'

@Component({
    selector: 'app-session-timeout-modal',
    templateUrl: './session-timeout-modal.component.html',
    styleUrls: ['./session-timeout-modal.component.scss'],
    standalone: false
})
export class SessionTimeoutModalComponent implements OnInit 
{
	constructor(
		public dialogRef: MatDialogRef<SessionTimeoutModalComponent>,
		private router: Router
	) 
	{
		dialogRef.disableClose = true;
	}

	ngOnInit() 
	{
	}

	closeModal(): void 
	{
		this.router.navigate(['/'])
		this.dialogRef.close();
	}
}
